import { render } from "./VersionsDialog.vue?vue&type=template&id=198456c3"
import script from "./VersionsDialog.vue?vue&type=script&lang=js"
export * from "./VersionsDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__